<template>
  <div class="whole_bg animate__animated animate__zoomIn"  v-if="isShow">
    <div class="nr_txt" >
      <div class="left" style="transform: scale(0.9);">
        <div class="left_txt" v-for="(item,index) in state.leftData1" :key="index">
          <div class="xiao_bt">{{item.name}}</div>
          <router-link :to="{path:item.path}" @click="handleRouterLinkClick">
            <div class="txt_nr"><img :src="item.img"></div>
          </router-link>
        </div>
      </div>

      <div class="middl">
        <div class="yq">
          <div class="d2yq">
          </div>
          <div class="d3yq"></div>
          <div class="d3tb"></div>
        </div>
        <div class="lh1 lh"><router-link :to="{path:'/huanjing'}" @click="handleRouterLinkClick"></router-link></div>
        <div class="lh2 lh"><router-link :to="{path:'/gbzntyj'}" @click="handleRouterLinkClick"></router-link></div>
        <div class="lh3 lh"><router-link :to="{path:'/datajc'}" @click="handleRouterLinkClick"></router-link></div>
        <div class="lh4 lh"><router-link :to="{path:'/plantmoxing'}" @click="handleRouterLinkClick"></router-link></div>
        <div class="lh5 lh"><router-link :to="{path:'/xuntian'}" @click="handleRouterLinkClick"></router-link></div>
        <div class="lh6 lh"><router-link :to="{path:'/sanchanrh'}" @click="handleRouterLinkClick"></router-link></div>
        <div class="xt1"></div>
        <div class="xt2"></div>
        <div class="xt3"></div>
        <div class="xt4"></div>
        <div class="xt5"></div>
        <div class="xt6"></div>


      </div>
      <div class="right" style="transform: scale(0.9);">
        <div class="left_txt" v-for="(item,index) in state.leftData2" :key="index">
          <div class="xiao_bt">{{item.name}}</div>
          <router-link :to="{path:item.path}" @click="handleRouterLinkClick">
            <div class="txt_nr"><img :src="item.img"></div>
          </router-link>
        </div>
      </div>


    </div>
    <div class="close" @click="circleClose">关闭</div>
  </div>
</template>
<script setup >
// @ is an alias to /src
import { useWindowSize } from "@vueuse/core";

const props =defineProps({
  isShow: {
    type: Boolean,
    default: "",
  },
})

import axios from "axios";
import { useRoute,useRouter } from "vue-router";
import { defineEmits } from 'vue'



import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  onBeforeUnmount, defineProps
} from "vue";


import Nav from "../components/nav.vue";


const state = reactive({
  scale:1,
  leftData1: [
    { name: "质量安全", path: "/suyuan", img:require('../assets/img/xm/sy.jpg'), },
    { name: "智能管理", path: "/zhinengGG", img:require('../assets/img/xm/gg.jpg'), },
    { name: "种植现状", path: "/plant", img:require('../assets/img/xm/xz.jpg'), }
  ],
  leftData2: [
    { name: "建设进度", path: "/gbzntjs", img:require('../assets/img/xm/jindu.jpg'), },
    { name: "灾害预警", path: "/qihouYj", img:require('../assets/img/xm/yujing.jpg'), },
    { name: "病虫诊断", path: "/binghai", img:require('../assets/img/xm/binghai.jpg'), },
  ],



});
const emit = defineEmits(['closeCircle1'])
function circleClose() {
  emit('closeCircle1', {show:false})

}
// const router = useRouter();
// const route = useRoute();
//
// // 获取当前路径
// const currentPath = route.path;
function handleRouterLinkClick() {
  // 例如，打印当前路径
  emit('closeCircle1', {show:false})
}
function windowSize(){
  const { width, height } = useWindowSize()
  // console.log(width,height)
  let wScale = width.value/1920
  let hScale = height.value/1080
  if(wScale < hScale){
    state.scale = wScale
  }else{
    state.scale = hScale
  }
}
// 在 onMounted 中初始化地图
onMounted(() => {
  windowSize()
  const handleResize = () => {
    console.log('浏览器窗口大小改变了！');
    windowSize()
  };
  window.addEventListener('resize', handleResize);

});



onUnmounted(() => {});
onBeforeUnmount(() => {
  // clearInterval(timer.value);
});
</script>

<style scoped lang="less">
.whole_bg {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100000;
  background: rgba(0,0,0,.8);
  display: flex;
  justify-content: center;
  align-items: center;
}


.close{
  position: absolute;
  top: 10px;
  right: 50px;
  color: #fff;
  font-size: 30px;
  text-align: center;
  cursor: pointer;
  padding: 20px 0;
  //border: 1px solid;
}

.big_bt {
  width: 100%;
  height: 88px;
  background: url("../assets/img/plantfx1/btbj.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.nr_txt {
  width: 100%;
  height: calc(100% - 120px);
  display: flex;
  //border: 1px solid #fff;
  .left_txt {
    width: 382px;
    height: 265px;
    background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/gaobiaosy/tpk.png")
    no-repeat top center;
    background-size: 100% 100%;
    padding-top: 20px;

    display: flex;
    flex-direction: column;
    a{
      display: block;
      width: 100%;
      flex: 1;
      //border: 1px solid #f00;
    }



    .xiao_bt{
      width: 100%;
      height: 50px;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/gaobiaosy/xtb1.png")
      no-repeat top center;
      color: #52E3BD;
      font-size: 20px;
      text-align: center;
      line-height: 10px;

    }
    .txt_nr{
      width: 100%;
      height: 100%;
      padding: 0px 10px 0;
      //border: 1px solid #f00;
      margin-top: -5px;
      img{
        width: 100%;
        height: 188px;
        //padding: 40px;
      }

    }

  }
  .left{
    flex: 1;
    height: 100%;
    //border: 1px solid #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;


  }
  .middl{
    width:970px;
    height: 100%;
    //border: 1px solid #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    flex-shrink: 0;
    .yq{
      width: 100%;
      height: 760px;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/gaobiaosy/wq.png")
      no-repeat top center;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .d2yq{
        width: 485px;
        height: 486px;
        background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/gaobiaosy/lq.png")
        no-repeat top center;
        background-size: 100% 100%;
        //animation: rotateAntiClockwise 15s linear infinite;
        position: absolute;

      }
      .d3yq{

        width: 379px;
        height: 382px;
        background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/gaobiaosy/nq.png")
        no-repeat top center;
        background-size: 100% 100%;
        position: relative;
        left: 2px;
        top: 1px;
        animation: rotateAntiClockwise1 25s linear infinite;
      }
      .d3tb{
        width: 140px;
        height: 140px;
        background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/gaobiaosy/nt.png")
        no-repeat top center;
        background-size: 100% 100%;
        position: absolute;
        left: 50%;
        margin-left: -72px;

      }

    }
    .lh{
      width: 200px;
      height: 220px;
      position: absolute;
      z-index: 99999;
      //border: 1px solid #f00;
      cursor: pointer;
      a{display: block;width: 100%;height: 100%;}
    }
    .lh1{
      width: 120px;
      left: 145px;
      top: 229px;
      transform: skew(326deg, 10deg);

    }
    .lh2{
      width: 200px;
      height: 150px;
      left: 404px;
      top: 82px;
      transform: skew(331deg, 179deg);
      //border: 1px solid #f00;


    }
    .lh3{
      width: 145px;
      height: 90px;
      left: 673px;
      top: 277px;
      transform: skew(319deg, 240deg);

    }
    .lh4{
      left: 673px;
      top: 500px;
      transform: skew(326deg, 10deg);

    }
    .lh5{
      width: 250px;
      height: 211px;
      left: 64px;
      top: 513px;
      transform: skew(347deg, 204deg);

    }
    .lh6{
      width: 277px;
      height: 200px;
      left: 343px;
      top: 709px;
      //transform: skew(4deg, 9deg);
      //border: 1px solid;

    }
    .xt1{
      width: 50%;
      height:10%;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/gaobiaosy/1.png")
      no-repeat top center;
      background-size: 100% 100%;
      position: absolute;
      left: -15%;
      top: 13%;
    }
    .xt2{
      width: 331px;
      height: 31px;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/gaobiaosy/2.png")
      no-repeat top center;
      background-size: 100% 100%;
      position: absolute;
      left: -17%;
      top: 50%;
    }
    .xt3{
      width: 50%;
      height:11%;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/gaobiaosy/3.png")
      no-repeat top center;
      background-size: 100% 100%;
      position: absolute;
      left: -15%;
      top: 80%;
    }
    .xt4{
      width: 49%;
      height:10%;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/gaobiaosy/1.png")
      no-repeat top center;
      background-size: 100% 100%;
      position: absolute;
      right: -13%;
      top: 13%;
      transform: scaleX(-1);
    }
    .xt5{
      width: 331px;
      height: 31px;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/gaobiaosy/2.png")
      no-repeat top center;
      background-size: 100% 100%;
      position: absolute;
      right: -17%;
      top: 50%;
      transform: scaleX(-1);
    }
    .xt6{
      width: 50%;
      height:11%;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/gaobiaosy/3.png")
      no-repeat top center;
      background-size: 100% 100%;
      position: absolute;
      right: -15%;
      top: 80%;
      transform: scaleX(-1);
    }

  }
  .right{
    flex: 1;
    height: 100%;
    //border: 1px solid #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }



}
@keyframes rotateAntiClockwise {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
@keyframes rotateAntiClockwise1 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}


@keyframes rotateAntiClockwise {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
@keyframes rotateAntiClockwise1 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
